import { Form } from "react-bootstrap";
import "../style/style-form-cv.css";

export default function FormFormation(props) {
  const currentYear = new Date().getFullYear();
  const years = Array.from(
    { length: currentYear - 1980 + 1 },
    (_, index) => currentYear - index
  );

  return (
    <>
      {props.formations.map((formation, index) => (
        <div className="row" style={{ textAlign: "start" }} key={index}>
          {index > 0 ? (
            <div className="col-12" style={{ marginTop: "10px" }}>
              <p
                href="#"
                style={{ fontWeight: "700", color: "red", textAlign: "end" }}
                onClick={() => props.onSupprimerFormation(index)}
              >
                X
              </p>
            </div>
          ) : null}

          <div className="col-12" style={{ display: "flex" }}>
            <div style={{ width: "33%", paddingRight: "2px" }}>
              <span style={{ fontWeight: "900" }}>Debut </span>

              <div className="row">
                <div className="col-sm-5">
                  <span style={{ fontWeight: "600", fontSize: "12px" }}>
                    Mois
                  </span>
                  <input
                    type="hidden"
                    className="form-control "
                    name="id_foramtion[]"
                  />
                  <Form.Select
                    className="form-control dateDebutFormation"
                    value={formation.moisDebut}
                    onChange={(e) =>
                      props.onChangeFormation(
                        index,
                        "moisDebut",
                        e.target.value
                      )
                    }
                  >
                    <option value=""></option>
                    <option value="01">Janvier</option>
                    <option value="02">Février</option>
                    <option value="03">Mars</option>
                    <option value="04">Avril</option>
                    <option value="05">Mai</option>
                    <option value="06">Juin</option>
                    <option value="07">Juillet</option>
                    <option value="08">Août</option>
                    <option value="09">Septembre</option>
                    <option value="10">Octobre</option>
                    <option value="11">Novembre</option>
                    <option value="12">Décembre</option>
                  </Form.Select>
                  {formation.moisDebut === "" ? (
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {props.msgErrFormation}
                    </p>
                  ) : null}
                </div>
                <div className="col-sm-5">
                  <span style={{ fontWeight: "600", fontSize: "12px" }}>
                    Année
                  </span>
                  <Form.Select
                    className="form-control dateDebutFormationAnnee"
                    value={formation.anneeDebut}
                    onChange={(e) =>
                      props.onChangeFormation(
                        index,
                        "anneeDebut",
                        e.target.value
                      )
                    }
                  >
                    <option value=""></option>
                    {years.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </Form.Select>
                  {formation.anneeDebut === "" ? (
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {props.msgErrFormation}
                    </p>
                  ) : null}
                </div>
              </div>
              {formation.anneeFin != "" &&
              formation.anneeDebut != "" &&
              (formation.anneeFin < formation.anneeDebut ||
                (formation.anneeFin == formation.anneeDebut &&
                  formation.moisDebut > formation.moisFin)) ? (
                <p style={{ fontSize: "12px", color: "red" }}>
                  {props.msgDateForm}
                </p>
              ) : null}
            </div>

            <div style={{ width: "33%", paddingRight: "2px" }}>
              <span style={{ fontWeight: "900" }}>Fin</span>

              <div className="row">
                <div className="col-sm-5">
                  <span style={{ fontWeight: "600", fontSize: "12px" }}>
                    Mois
                  </span>
                  <Form.Select
                    value={formation.moisFin}
                    onChange={(e) =>
                      props.onChangeFormation(index, "moisFin", e.target.value)
                    }
                    className="form-control datefinFormation"
                  >
                    <option value=""></option>
                    <option value="01">Janvier</option>
                    <option value="02">Février</option>
                    <option value="03">Mars</option>
                    <option value="04">Avril</option>
                    <option value="05">Mai</option>
                    <option value="06">Juin</option>
                    <option value="07">Juillet</option>
                    <option value="08">Août</option>
                    <option value="09">Septembre</option>
                    <option value="10">Octobre</option>
                    <option value="11">Novembre</option>
                    <option value="12">Décembre</option>
                  </Form.Select>
                </div>
                <div className="col-sm-5">
                  <span style={{ fontWeight: "600", fontSize: "12px" }}>
                    Année
                  </span>
                  <Form.Select
                    value={formation.anneeFin}
                    onChange={(e) =>
                      props.onChangeFormation(index, "anneeFin", e.target.value)
                    }
                    name="annee_fin[]"
                    id=""
                    className="form-control datefinFormationAnne"
                  >
                    <option value=""></option>
                    {years.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </Form.Select>
                </div>
              </div>
              {(formation.moisFin === "" || formation.anneeFin === "") &&
              formation.encoureFormation == 0 ? (
                <p style={{ fontSize: "12px", color: "red" }}>
                  {props.msgErrEncoure}
                </p>
              ) : null}
            </div>

            <div
              style={{ width: "33%", paddingRight: "2px", textAlign: "center" }}
            >
              <span style={{ fontWeight: "900" }}>En cours </span>
              <div className="row">
                <div className="col-12 ">
                  <Form.Check
                    type="checkbox"
                    id="checkbox"
                    value={
                      formation.encoureFormation != null
                        ? formation.encoureFormation
                        : 0
                    }
                    onChange={() => props.onToggleEncoureFormation(index)}
                    checked={formation.encoureFormation}
                    style={{
                      fontSize: "35px",
                      marginTop: "7%",
                      marginLeft: "45%",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-3 " style={{ marginTop: "15px" }}>
            <span style={{ fontWeight: "900" }}>Titre de formation </span>
            <Form.Select
              type="text"
              className="form-control"
              value={formation.titreFormation}
              onChange={(e) =>
                props.onChangeFormation(index, "titreFormation", e.target.value)
              }
            >
              <option value="">---</option>
              <option value="Certificat">Certificat</option>
              <option value="Brevet">Berevet</option>
              <option value="Bac">Bac</option>
              <option value="Bac+2">Bac+2</option>
              <option value="Licence">Licence</option>
              <option value="Bac+4">Bac+4</option>
              <option value="Master">Master</option>
              <option value="Doctorat">Doctorat</option>
              <option value="Autres">Autres</option>
            </Form.Select>
            {formation.titreFormation === "" ? (
              <p style={{ fontSize: "12px", color: "red" }}>
                {props.msgErrFormation}
              </p>
            ) : null}
          </div>

          <div className="col-sm-3 " style={{ marginTop: "15px" }}>
            <span style={{ fontWeight: "900" }}>Spécialité</span>
            <input
              type="text"
              className="form-control "
              value={formation.specialite}
              onChange={(e) =>
                props.onChangeFormation(index, "specialite", e.target.value)
              }
            />
            {formation.specialite === "" ? (
              <p style={{ fontSize: "12px", color: "red" }}>
                {props.msgErrFormation}
              </p>
            ) : null}
          </div>

          <div className="col-sm-3 " style={{ marginTop: "15px" }}>
            <span style={{ fontWeight: "900" }}>Etablissement</span>
            <input
              value={formation.etablissmenet}
              type="text"
              className="form-control"
              onChange={(e) => props.onChangeEtablissement(e, index)}
            />
            {props.searchInputEtablissement.length > 2 &&
            index === props.currentIndex
              ? props.filteredResultsEtablissement.map((item, i) => {
                  return (
                    <option
                      key={i}
                      value={item.etablissement}
                      onClick={(e) => props.selectItemsEtablissement(e, index)}
                    >
                      {item.etablissement}
                    </option>
                  );
                })
              : ""}
            {formation.etablissmenet === "" ? (
              <p style={{ fontSize: "12px", color: "red" }}>
                {props.msgErrFormation}
              </p>
            ) : null}
          </div>

          <div className="col-sm-3 " style={{ marginTop: "15px" }}>
            <span style={{ fontWeight: "900" }}>Ville </span>
            <input
              name="ville[]"
              id="ville"
              type="text"
              className="form-control"
              value={formation.ville}
              onChange={(e) =>
                props.onChangeFormation(index, "ville", e.target.value)
              }
            />
            {formation.ville === "" ? (
              <p style={{ fontSize: "12px", color: "red" }}>
                {props.msgErrFormation}
              </p>
            ) : null}
          </div>

          <div className="col-sm-12" style={{ marginTop: "15px" }}>
            <textarea
              className="form-control"
              name="description_formation[]"
              id="form6Example7"
              rows="4"
              cols="54"
              value={
                formation.descriptionFormation != null
                  ? formation.descriptionFormation
                  : ""
              }
              onChange={(e) =>
                props.onChangeFormation(
                  index,
                  "descriptionFormation",
                  e.target.value
                )
              }
              placeholder="Saisire une descrition detaillée de votre formation"
            ></textarea>
          </div>
        </div>
      ))}
    </>
  );
}
